<div class="mb-5">
    <h1 class="text-3xl text-gray-800 dark:text-gray-100 font-semibold">{{ title }}</h1>
    <p class="text-sm text-gray-500 dark:text-gray-400">{{ subtitle }}</p>
</div>
